import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-information-shared-popup',
  standalone: false,
  templateUrl: './information-shared-popup.component.html',
  styleUrl: './information-shared-popup.component.scss'
})
export class InformationSharedPopupComponent {

  constructor(private dialogRef: MatDialogRef<InformationSharedPopupComponent>) {}
  
  closeDialog() {
    this.dialogRef.close()
  }
}
